import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const SETUP_URL = "/actions/refresh?modal[type]=sendingSettings";

const Card = ({ href, title, description, badge, tone, current }) => (
  <a
    className="ea-explore-card"
    href={href}
    data-current={current ? "" : undefined}
  >
    <div className="ea-explore-card__head">
      <p className="s2">{title}</p>
      <span className={`ea-status ea-status--${tone}`}>{badge}</span>
    </div>
    <p className="p5">{description}</p>
  </a>
);

Card.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  badge: PropTypes.string.isRequired,
  tone: PropTypes.string.isRequired,
  current: PropTypes.bool,
};

// The cards of Email Automations in the Explore list. PRESS and PERFORM have no other workflow
// yet, so their first card is the one that sets up sending.
const ExploreEmailCards = ({
  access,
  showingEmail,
  hasActive,
  domainVerified,
}) => {
  const { t } = useTranslation("coaching-portal");
  const tr = (key) => t(`emailAutomations.explore.${key}`);
  const ownWorkflows = access === "push" || access === "pull";

  return (
    <>
      {ownWorkflows ? null : (
        <Card
          href={SETUP_URL}
          title={tr("gettingStarted.title")}
          description={tr("gettingStarted.description")}
          badge={tr(domainVerified ? "badges.active" : "badges.setUp")}
          tone={domainVerified ? "active" : "setup"}
        />
      )}
      <Card
        href={`/actions/refresh?access=${access}&view=email`}
        title={tr("emailAutomations.title")}
        description={t(
          `emailAutomations.explore.emailAutomations.descriptions.${access}`,
          {
            defaultValue: tr("emailAutomations.description"),
          }
        )}
        badge={tr(hasActive ? "badges.active" : "badges.setUp")}
        tone={hasActive ? "active" : "setup"}
        current={showingEmail}
      />
    </>
  );
};

ExploreEmailCards.propTypes = {
  access: PropTypes.string.isRequired,
  showingEmail: PropTypes.bool,
  hasActive: PropTypes.bool,
  domainVerified: PropTypes.bool,
};

export default ExploreEmailCards;
